export const INITIATIVE_USER_ROLES = {
  owner: 'owner',
  admin: 'admin',
  member: 'member',
  applicant: 'applicant',
  follower: 'follower',
} as const
export type InitiativeUserRole = keyof typeof INITIATIVE_USER_ROLES
